var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_762_6804)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_762_6804)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_762_6804)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 54C41.9117 54 54 41.9117 54 27C54 12.0883 41.9117 0 27 0C12.0883 0 0 12.0883 0 27C0 41.9117 12.0883 54 27 54Z",
    fill: "#6900FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8044 19.2628H35.2854M38.7664 19.2628H35.2834M35.2834 19.2628V15.7818M35.2834 19.2628V22.7448M33.9774 30.2448L29.1984 31.1708C25.9704 29.5508 23.9764 27.6898 22.8154 24.7878L23.7094 19.9948L22.0214 15.4998H17.6684C17.3637 15.4893 17.0605 15.5456 16.7798 15.6647C16.4992 15.7838 16.248 15.9627 16.0437 16.189C15.8395 16.4154 15.6872 16.6836 15.5975 16.975C15.5078 17.2663 15.4829 17.5738 15.5244 17.8758C16.0114 21.1058 17.4504 26.9628 21.6554 31.1668C26.0714 35.5818 32.4314 37.4998 35.9324 38.2608C36.2466 38.3258 36.5714 38.3187 36.8824 38.2401C37.1934 38.1615 37.4826 38.0134 37.7281 37.8069C37.9737 37.6005 38.1692 37.341 38.3 37.0481C38.4309 36.7552 38.4936 36.4364 38.4834 36.1158V31.9568L33.9774 30.2448Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_762_6804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_762_6804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_762_6804"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.ce030d22f05af8a37152fb5595d2a234.svg";
export { ForwardRef as ReactComponent };